import CountryBillingConfig from 'types/models/CountryBillingConfig';
import axiosInstance from './axios';

export const getCountries = async (): Promise<CountryBillingConfig[] | null> => {
  try {
    const { data } = await axiosInstance({
      method: 'GET',
      url: 'venues/get-countries',
    });
    return parseCountries(data);
  } catch (error) {
    console.log(error);
    return null;
  }
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parseCountries = (countries: any[]): CountryBillingConfig[] => {
  return countries.map((country: any) => parseCountry(country));
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const parseCountry = (country: any): CountryBillingConfig => {
  return {
    id: country.id,
    countryName: country.country_name,
  };
};
